import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './PreviewUiElement.module.scss';

export const PreviewUiElement = ({ className, children }: Props) => (
    <div className={classNames(styles.default, className)}>
        {children}
    </div>
);

type Props = PropsWithChildren<{ className?: string }>;